<template>
	<div class="erco-text-area">
		<label class="label_">
			<span class="_text text-muted">{{ label || '&nbsp;' }}</span>
			<textarea class="textarea form-control"
			          @change="handleTextChange">{{ text }}</textarea>
		</label>
	</div>
</template>
<script>
export default {
	name: 'ErcoTextAreaAtom',

	data() {
		return {};
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		text: {
			type: String,
			required: true,
		},
	},
	methods: {
		handleTextChange(value) {
			this.$emit('change', value.target.value);
		},
	},
};
</script>

<style lang="scss">

	.erco-text-area {
		& > .label_ {
			height: 100%;
			width: 100%;

			& > ._text {
				margin: 0;
			}

			& > .textarea {
				height: 100%;
				margin-top: 0.4rem;
				width: 100%;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoTextArea.vue?e312535a